export const nl = {
  main: {
    color_hex: 'Kleur in hexadecimale notatie, start met #',
    language: 'Nederlands',
    restricted_field_name: 'Deze veldnaam is gereserveerd en kan niet worden gebruikt',
    asset_type_required: 'Selecteer minstens één asset type of maak het veld globaal',
    searchbar: 'Zoek (min. 3 karakters)',
    title: 'Admin',
    logout: 'Uitloggen',
    english: 'Engels',
    dutch: 'Nederlands',
    french: 'Frans',
    spanish: 'Spaans',
    danish: 'Deens',
    romanian: 'Roemeens',
    italian: 'Italiaans',
    norwegian: 'Noors',
    german: 'Duits',
    drop_image: 'Sleep je afbeeldingsbestand hier',
  },
  ra: {
    tree: {
      add_child_node: 'Subcategorie toevoegen',
      add_node_after: 'Categorie toevoegen na',
      add_node_before: 'Categorie toevoegen voor',
      close: 'Sluiten',
      expand: 'Openen',
    },
  },
  resources: {
    categories: {
      name: 'Categorie |||| Categorieën',
      fields: {
        name: 'Categorienaam',
      },
    },
    users: {
      name: 'Gebruiker |||| Gebruikers',
      fields: {
        category: 'Categorie',
        connection: 'Connectie',
        email: 'E-mail',
        familyName: 'Achternaam',
        firstName: 'Voornaam',
        language: 'Taal',
        userRoles: 'Rollen',
      },
    },
    priorities: {
      name: 'Prioriteit |||| Prioriteiten',
    },
    branding: {
      name: 'Logo',
    },
    invitations: {
      name: 'Uitnodiging |||| Uitnodigingen',
      fields: {
        email: 'E-mail',
      },
    },
    'asset-types': {
      name: 'Asset Type |||| Asset Types',
      fields: {
        name: 'Naam',
      },
    },
    'asset-statuses': {
      name: 'Asset Status |||| Asset Statussen',
      fields: {
        name: 'Naam',
      },
    },
    'asset-custom-fields': {
      name: 'Asset Custom Field |||| Asset Custom Fields',
      fields: {
        name: 'Naam',
        globalField: 'Globaal (alle asset types)',
        assetTypeIds: 'Asset Types',
      },
    },
  },
}
